export default __webpack_public_path__ + "static/media/RoxanaGonzalez.b85a7eb6.png";